var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroCompanySector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0925 3.65613C14.3611 3.34086 14.8345 3.30308 15.1498 3.57174C15.465 3.8404 15.5028 4.31377 15.2342 4.62904L14.5391 5.44461C13.3326 6.86043 11.1312 6.81451 9.98477 5.34962C9.46288 4.68276 8.48121 4.60755 7.86383 5.18713L7.17664 5.83224C6.87465 6.11575 6.40001 6.10076 6.11651 5.79877C5.83301 5.49677 5.848 5.02214 6.14999 4.73863L6.83717 4.09352C8.09725 2.91059 10.1008 3.06409 11.166 4.42515C11.7277 5.14289 12.8063 5.16538 13.3975 4.4717L14.0925 3.65613ZM9.35342 7.25H4.97322L4.00617 18.8547C3.92114 19.875 4.7263 20.75 5.75012 20.75H8.57652C8.60561 20.75 8.63451 20.7493 8.66323 20.7479V20.75L18.1095 20.75C19.112 20.75 19.9096 19.9095 19.8571 18.9083L19.3386 9.02573L15.2003 12.1295L14.7225 9.26293L9.76743 12.2181L9.35342 7.25ZM18.1095 19.25H10.3091C10.3274 19.1219 10.3317 18.9896 10.3205 18.8547L9.90608 13.8819L13.6041 11.6764L14.1263 14.8099L17.988 11.9136L18.3591 18.9869C18.3666 19.1299 18.2527 19.25 18.1095 19.25ZM6.20759 10.5L6.35342 8.75H7.97322L8.11905 10.5H6.20759ZM6.08259 12L5.50098 18.9792C5.48884 19.125 5.60386 19.25 5.75012 19.25H8.57652C8.72278 19.25 8.8378 19.125 8.82566 18.9792L8.24405 12H6.08259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCompanySector);
export default __webpack_public_path__ + "static/media/hero-company-sector.b38a8366780f73ead260267b75b9feb5.svg";
export { ForwardRef as ReactComponent };